import { render, staticRenderFns } from "./DomesticProjects.vue?vue&type=template&id=90b4e40a&scoped=true&"
import script from "./DomesticProjects.vue?vue&type=script&lang=js&"
export * from "./DomesticProjects.vue?vue&type=script&lang=js&"
import style0 from "./DomesticProjects.vue?vue&type=style&index=0&id=90b4e40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4e40a",
  null
  
)

export default component.exports